export default "__VITE_ASSET__D1fWgEMO__"